module.exports = __webpack_public_path__ + "public/images/octopus.2a093d6da733e8816083dd890ae4273f.png";